import apiClient from './apiClient'

export const login = async (username, password) => {
  try {
    const response = await apiClient.post('/auth/login/', {
      username,
      password
    })
    
    if (response.data.access) {
      localStorage.setItem('accessToken', response.data.access)
      localStorage.setItem('isAdmin', response.data.is_staff)
      localStorage.setItem('username', username)
      return response.data
    }
    
    throw new Error('No se recibió token de acceso')
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al iniciar sesión')
  }
}

export const register = async (userData) => {
  try {
    const response = await apiClient.post('/auth/register/', userData);
    
    if (response.data) {
      return {
        message: response.data.message,
        email: response.data.email,
        userId: response.data.user_id
      };
    }
    
    throw new Error(response.data?.message || 'Error en el registro');
  } catch (error) {
    if (error.response?.data?.error) {
      const customError = new Error('Errores de validación');
      customError.errors = error.response.data.error;
      throw customError;
    }
    throw error;
  }
};

export const logout = () => {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('isAdmin')
  localStorage.removeItem('username')
}

export const isAuthenticated = () => {
  return localStorage.getItem('accessToken') !== null
}

export const isAdmin = () => {
  return localStorage.getItem('isAdmin') === 'true'
}

export const getUsername = () => {
  return localStorage.getItem('username')
}

export const getAccessToken = () => {
  return localStorage.getItem('accessToken')
}

export const getUserInfo = async () => {
  try {
    const token = getAccessToken()
    const response = await apiClient.get('/auth/profile/', {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al obtener información del usuario')
  }
}

export const updateUserProfile = async (userData) => {
  try {
    const response = await apiClient.put('/auth/profile/', userData)
    return response.data
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Error al actualizar el perfil'
    throw new Error(errorMessage)
  }
}

export const changePassword = async ({old_password, new_password}) => {
  try {
    const response = await apiClient.post('/auth/change-password/', {
      old_password,
      new_password
    })
    // Update token after password change if provided
    if (response.data.access) {
      localStorage.setItem('accessToken', response.data.access)
    }
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}

export const verifyEmail = async (data) => {
  const response = await apiClient.post('/auth/verify-email/', {
    email: data.email,
    code: data.code
  });
  return response.data;
};

export const resendVerification = async (email) => {
  const response = await apiClient.post('/auth/resend-verification/', {
    email
  });
  return response.data;
};

export const requestVerificationCode = async (type, newEmail = null, password = null) => {
  try {
    const token = getAccessToken()
    const response = await apiClient.post('/auth/verify-change/', {
      type,
      new_email: newEmail,
      password: password
    }, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data
  } catch (error) {
    console.error('Verification code request error:', error.response?.data || error) // Debug
    throw error.response?.data || { error: 'Error al solicitar verificación' }
  }
}

export const updateEmailWithVerification = async (email, verificationCode) => {
  try {
    const response = await apiClient.put('/auth/profile/', {
      email,
      verification_code: verificationCode
    })
    return response.data
  } catch (error) {
    throw error.response?.data || error
  }
}